import React, { useState } from 'react';
import { Route, Routes } from "react-router-dom";
import axios from 'axios';

import './App.css';

// Import Routes

import Home from './routes/Home';
import About from './routes/About';
import Apply from './routes/Apply';
import Books from './routes/Books';
import Find from './routes/Find';
import Donate from './routes/Donate';
import Contact from './routes/Contact';
import Join from './routes/Join';
import Report from './routes/Report';
import Login from './routes/Login';
import Events from './routes/Events';
import EventSignin from './routes/EventSignIn';
import Dashboard from './routes/Dashboard';
import Recover from './routes/Recover';

// Page states
import { LOGIN_STATES } from './data/Login/LoginStates';
import { ROUTES } from './data/GeneralData';

// Navbar and Footer

import Navbar from './components/General/Navbar';
import Footer from "./components/General/Footer";
import LoadingScreen from './components/General/LoadingScreen';

function useFetchData() {
  axios.defaults.withCredentials = true;
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  React.useEffect(() => {
    if (!userData) {
      setLoading(true);
      axios.get('/api/user', { withCredentials: true })
        .then((res) => {
          setUserData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        })
    }

  }, []);
  return { loading, userData };
}

export default function App() {
  const { loading, userData } = useFetchData();

  if (loading) {
    return <LoadingScreen />
  }

  return (
    <div className="app">
      <nav>
        <Navbar userData={userData ? userData : null} />
      </nav>

      <main>
        <Routes>
          <Route path={ROUTES.HOME} element={<Home userData={userData} />} />
          <Route path={ROUTES.ABOUT} element={<About userData={userData} />} />
          <Route path={ROUTES.APPLY} element={<Apply userData={userData} />} />
          <Route path={ROUTES.BOOKS} element={<Books userData={userData} />} />
          <Route path={ROUTES.FIND} element={<Find userData={userData} />} />
          <Route path={ROUTES.DONATE} element={<Donate userData={userData} />} />
          <Route path={ROUTES.CONTACT} element={<Contact userData={userData} />} />
          <Route path={ROUTES.JOIN} element={<Join userData={userData} />} />
          <Route path={ROUTES.REPORT} element={<Report userData={userData} />} />
          <Route path={ROUTES.LOGIN} element={<Login loginState={LOGIN_STATES.LOGIN} userData={userData} />} />
          <Route path={ROUTES.SIGNUP} element={<Login loginState={LOGIN_STATES.SIGNUP} userData={userData} />} />
          <Route path={ROUTES.FORGOT_PASSWORD} element={<Login loginState={LOGIN_STATES.FORGOT} userData={userData} />} />
          <Route path={ROUTES.EVENTS} element={<Events userData={userData} />} />
          <Route path={ROUTES.EVENT_SIGNIN} element={<EventSignin userData={userData ? userData : null} />} />
          <Route path={ROUTES.DASHBOARD} element={<Dashboard userData={userData ? userData : null} />} />
          {/* <Route path="/sisterhood" element={<Sisterhood userData={userData} />} /> */}
          <Route path={ROUTES.RECOVER} element={<Recover userData={userData} />} />
        </Routes>
      </main>

      <footer>
        <Footer />
      </footer>

    </div>

  );
}